module.exports = require("core-js/library/fn/object/values");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/values.js
// module id = 573
// module chunks = 25